const INITIAL_VALUES = {
  plazaNum: '',
  plazaName: '',
  zone: null,
};

export default INITIAL_VALUES;
